// extracted by mini-css-extract-plugin
export default {"icon":"_2lnqG","more":"s5Ph-","actions":"_3xYam","small":"_2z2ZN","extended":"_3Gj7o","actionsTop":"_1zYfJ _3xYam","buttonBorder":"_1-uma"};